import React, { useState, useContext, useEffect, useRef } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Checkbox, FormControlLabel, RadioGroup, MenuItem, FormLabel, Radio, FormHelperText, CircularProgress } from '@material-ui/core';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { EvaluationCategoryData } from '../../../services';
import moment from "moment";
import Helper from '../../../common/Helper';
import Validations from "../../../common/Validations";
import {
    MuiPickersUtilsProvider,
    DatePicker,
} from '@material-ui/pickers';
import Utils from '@date-io/moment';
import { AppDataContext } from '../../../common/AppContext';

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: '400px'
    },
    notesHeader: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(1.5),
    },
    dialogWidth: {
        overflow: 'auto',
        minWidth: '400px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '300px'
        }
    },
    ErrorName: {
        color: 'red',
    },
    nameContainer: {
        margin: 15,
        display: 'flex',
        flexGrow: '1',
        flexDirection: 'column'
    },
    formLabel: {
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
    userLabel: {
        paddingLeft: '10px',
    },
    addButton: {
        position: 'relative',
        top: theme.spacing(-4),
        paddingRight: theme.spacing(1)
    },
    progress: {
        marginLeft: '50%',

    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        color: '#fff'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography className="font500" variant="subtitle1" noWrap>{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: '15px 15px',
        [theme.breakpoints.down(281)]: {
            width: '218px',
        },
        [theme.breakpoints.between(281, 322)]: {
            width: '258px',
        },
        [theme.breakpoints.between(321, 556)]: {
            width: '275px'
        },
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const AddNewEvent = (props) => {
    const classes = useStyles();
    const InitialEvent = { id: 0, eventName: '', seasonCycleYear: '2021', seasonType: 0, seasonTypeName: '', isNBAEvent: true, eventFrom: null, eventTo: null, gameType: 0, country: 0, state: 0, stateOther: '', city: '', evaluationMode: null, scoutingCategory: 0, scoutingSubCategory: 0 };
    const { gameTypeList, countryList, getCountryList, stateList,getStateList, category, subCategory, evaluationEvents, competency, getUpdatedEvaluationEvents, getCategoryData, getCompetencyData, seasonTypeList } = useContext(AppDataContext)
    const normalizeEvent = (evt) => ({ ...evt, scoutingCategory: evt.scoutingCategory || 0, scoutingSubCategory: evt.scoutingSubCategory || 0 });
    const [eventData, setEventData] = useState(props.editEvent !== null && props.editEvent !== undefined ? normalizeEvent(props.editEvent) : InitialEvent);
    const [isNBAEvent, setIsNBAEvent] = useState(true);
    const [eventName, setEventName] = useState();
    const [formDataError, setFormDataError] = useState([]);
    const [selectedSeasonType, setSelectedSeasonType] = useState({});
    const [headText, setHeadText] = useState('Add New Event');
    const [seasonYearList, setSeasonYearList] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [scoutingCategoryList, setScoutingCategoryList] = useState(
        Array.isArray(props.scoutingCategoryList) ? props.scoutingCategoryList.filter(c => c.categoryActive) : []
    );
    const hasFetchedScoutingRef = useRef(false);

    // Keep the list in sync when the parent supplies (or later refreshes) preloaded scouting categories.
    useEffect(() => {
        if (Array.isArray(props.scoutingCategoryList)) {
            setScoutingCategoryList(props.scoutingCategoryList.filter(c => c.categoryActive));
        }
    }, [props.scoutingCategoryList]);

    useEffect(() => {
        //   getSeasonData()
        if (countryList.length === 0) {
            getCountryList();
        }
        if (stateList.length === 0) {
            getStateList();
        }

        // Only fetch when the parent did not preload the list; the ref guard prevents a duplicate call.
        if (!Array.isArray(props.scoutingCategoryList) && !hasFetchedScoutingRef.current) {
            hasFetchedScoutingRef.current = true;
            EvaluationCategoryData.getScoutingCategoryMaster().then((result) => {
                if (Array.isArray(result)) {
                    setScoutingCategoryList(result.filter(c => c.categoryActive));
                }
            }).catch(() => { });
        }

        let currentDate = moment().format('YYYY-MM-DD')
        let currentYear = moment().format('YYYY');
        if (eventData.id === 0) {
            let data = { ...eventData };
            data['seasonCycleYear'] = currentYear;
            setEventData(data);
        }
        let _seasonYearList = [];
        let  iYear = 2021; let _startYear = 2021;
        for (iYear = _startYear; iYear <= parseInt(currentYear); iYear++) {
            _seasonYearList.push(iYear);
        }
        setSeasonYearList(_seasonYearList);

    }, [])

    const handleClose = () => {
        props.handleCloseClick();
    };

    useEffect(() => {
        if (props.editEvent !== undefined && props.editEvent !== null) {
            if (props.editEvent.id > 0) {
                let seasonType = seasonTypeList.find(x => x.id === eventData.seasonType)
                setSelectedSeasonType(seasonType)
                setHeadText('Update Event')

            }

        }
    }, [props.editEvent]);



    useEffect(() => {
        if (Object.keys(formDataError).length) isFormDataValid();
    }, [eventData]);





    const handleChange = (value, name) => {
        let data = { ...eventData };
        if (name === 'eventName') {
            data['eventName'] = value;
            setEventName(value);
        }
        if (name === 'isNBAEvent') {
            setIsNBAEvent(value)
        }
        if (name === 'eventFrom') {
            data['eventTo'] = null;
            data['eventFrom'] = value !== null && value !== "" ? Helper.FormatDate(value) : null;
        } else if (name === 'eventTo') {
            data['eventTo'] = value !== null && value !== "" ? Helper.FormatDate(value) : null;
        }
        else {
            data[name] = value;
        }




        setEventData(data);
    };

    const handleSeasonSelection = (newValue) => {
        let data = { ...eventData };
        if (newValue !== null) {
            data['seasonType'] = newValue.id;
            data['seasonTypeName'] = newValue.displayName;
        } else {
            data['seasonType'] = 0;
            data['seasonTypeName'] = '';
        }
        setEventData(data);
        setSelectedSeasonType(newValue)
    }

    const selectedScoutingCategory = scoutingCategoryList.find(c => c.id === eventData.scoutingCategory) || null;
    const scoutingSubCategoryOptions = selectedScoutingCategory && Array.isArray(selectedScoutingCategory.subCategories)
        ? selectedScoutingCategory.subCategories.filter(s => s.subCategoryActive)
        : [];
    const selectedScoutingSubCategory = scoutingSubCategoryOptions.find(s => s.id === eventData.scoutingSubCategory) || null;

    const handleScoutingCategoryChange = (newValue) => {
        let data = { ...eventData };
        data['scoutingCategory'] = newValue ? newValue.id : 0;
        data['scoutingSubCategory'] = 0; // reset subcategory whenever the category changes
        setEventData(data);
    }

    const handleScoutingSubCategoryChange = (newValue) => {
        let data = { ...eventData };
        data['scoutingSubCategory'] = newValue ? newValue.id : 0;
        setEventData(data);
    }

    const isFormDataValid = () => {
        let errors = [];
        Object.entries(eventData).forEach(([key, value]) => {
            let field = false;
            switch (key) {
                case "eventName":
                    field = Validations.Validate("Event Name", value, { Required: true });
                    break;
                case "seasonType":
                    field = Validations.Validate("Season Type", value, { Min: 1 });
                    if (field && !field.isValid) {
                        field.validationMessage = "Season Type is required."
                    }
                    break;
                // case "gameType":
                //     field = Validations.Validate("Game Type", value, { Min: 1 });
                //     if (field && !field.isValid) {
                //         field.validationMessage = "Game Type is required."
                //     }
                //     break;
                case "country":
                    field = Validations.Validate("Country", value, { Min: 1 });
                    if (field && !field.isValid) {
                        field.validationMessage = "Country is required."
                    }
                    break;
                case "state":
                    if (eventData.country === 1) {
                        field = Validations.Validate("State", value, { Min: 1 });
                        if (field && !field.isValid) {
                            field.validationMessage = "State is required."
                        }
                    }
                    break;
                case "city":
                    field = Validations.Validate("City", value, { Required: true });
                    break;
                case "eventFrom":
                    field = Validations.Validate("Start Date", value, { Required: true });
                    break;
                case "eventTo":
                    field = Validations.Validate("To Date", value, { Required: true });
                    break;
                case "evaluationMode":
                    field = Validations.Validate("Event Mode", value, { Required: true });
                    break;

                case "scoutingCategory":
                    field = Validations.Validate("Scouting Category", value, { Min: 1 });
                    if (field && !field.isValid) {
                        field.validationMessage = "Scouting Category is required."
                    }
                    break;
                case "scoutingSubCategory":
                    {
                        let cat = scoutingCategoryList.find(c => c.id === eventData.scoutingCategory);
                        let activeSubs = cat && Array.isArray(cat.subCategories)
                            ? cat.subCategories.filter(s => s.subCategoryActive)
                            : [];
                        if (activeSubs.length > 0) {
                            field = Validations.Validate("Scouting Sub Category", value, { Min: 1 });
                            if (field && !field.isValid) {
                                field.validationMessage = "Scouting Sub Category is required."
                            }
                        }
                    }
                    break;


            }

            if (field && !field.isValid) {
                errors[key] = field.validationMessage;
            }
        });

        if (Object.keys(errors).length) {
            console.log('Validation errors:', { ...errors });
            console.log('Current eventData:', eventData);
            setFormDataError(errors);
            return false;
        }
        setFormDataError([]);
        return true;
    }

    const handleSubmit = () => {
        let event = props.evaluationEvents.find(x => x.eventName === eventName);
        if (isFormDataValid()) {
            setIsSaving(true);
            if (eventData.id === 0) {
                if (event === undefined) {
                    EvaluationCategoryData.insertEvent({ ...eventData })
                        .then(res => {
                            //props.refreshEventList()
                            props.handleCloseClick()
                            props.showAlert('Evaluation Event created successfully.', 'success');
                            props.handleEventAdded(eventData)

                        })
                        .catch(err => {
                            console.log(err);
                            props.showAlert('some error occured, try again later.', 'error');
                        })
                        .finally(() => {
                            setIsSaving(false);
                        })
                } else {
                    setIsSaving(false);
                    props.showAlert('Duplicate event name.', 'warning');
                    handleClose();
                }
            } else {
                EvaluationCategoryData.updateEvent({ ...eventData })
                    .then(res => {
                        //props.refreshEventList()
                        props.handleCloseClick()
                        props.showAlert('Evaluation Event Updated successfully.', 'success');
                        props.handleEventAdded()

                    })
                    .catch(err => {
                        console.log(err);
                        props.showAlert('some error occured, try again later.', 'error');
                    })
                    .finally(() => {
                        setIsSaving(false);
                    })

            }
        }
    };

    return (
        <div>
            <Dialog maxWidth="sm" onClose={(event, reason) => { if (reason !== 'backdropClick') handleClose(); }} aria-labelledby="customized-dialog-title" open={props.open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {headText}
                </DialogTitle>
                <DialogContent dividers className={classes.dialogWidth}>

                    <Grid container spacing={2} className={classes.formContainer}>
                        <Grid item sm={12}>
                            <TextField id="DataField" variant="outlined" fullWidth={true}
                                label={<Typography variant="body2">Event Name</Typography>}
                                size="small"
                                value={eventData.eventName}
                                name="Name"
                                onChange={(e) => handleChange(e.target.value, 'eventName')}
                                error={formDataError.eventName && true || false}
                                helperText={formDataError.eventName}
                                inputProps={{ maxLength: 150 }}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            {/* <TextField id="DataField" variant="outlined" fullWidth={true}
                                label={<Typography variant="body2">Season Cycle Year</Typography>}
                                size="small"
                                value={eventData.seasonCycleYear}
                                name="Name"
                                //  onChange={(e) => handleChange(e.target.value, 'competencyName')}
                                //  error={errorText}
                                inputProps={{ maxLength: 150 }}
                            /> */}
                             <TextField className={classes.ddSeasonYear}
                                id="DataField"
                                name="Name"
                                select
                                label={<Typography variant="body2">Season Cycle Year</Typography>}
                                value={String(eventData.seasonCycleYear)}
                                onChange={(e) => handleChange(e.target.value, 'seasonCycleYear')}
                                size="small"
                                variant='outlined'
                                fullWidth={true}
                                style={{ marginRight: 16 }}
                            >
                                {seasonYearList && seasonYearList.map(yr => {
                                    return <MenuItem key={yr} value={String(yr)}>{yr}</MenuItem>
                                })}
                            </TextField>

                        </Grid>
                        <Grid item sm={6}>
                            <Autocomplete
                                value={!!selectedSeasonType && selectedSeasonType}
                                id="combo-box-watchlist"
                                options={seasonTypeList}
                                fullWidth={true}
                                size='small'
                                onChange={(event, newValue) => {
                                    handleSeasonSelection(newValue)
                                }}
                                getOptionLabel={(option) => option.displayName}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label={<Typography variant="body2">Season Type</Typography>}
                                    variant="outlined"
                                    error={formDataError.seasonType && true || false}
                                    helperText={formDataError.seasonType && formDataError.seasonType} />}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <MuiPickersUtilsProvider utils={Utils}>
                                <DatePicker
                                    value={eventData.eventFrom && eventData.eventFrom !== null ? moment(eventData.eventFrom) : null}
                                    format='MM/DD/YYYY'
                                    inputVariant='outlined'
                                    label="Start Date"
                                    size='small'
                                    fullWidth
                                    onChange={(date) => handleChange(date, 'eventFrom')}
                                    error={formDataError.eventFrom && true || false}
                                    helperText={formDataError.eventFrom && formDataError.eventFrom}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item sm={6}>
                            <MuiPickersUtilsProvider utils={Utils}>
                                <DatePicker
                                    value={eventData.eventTo && eventData.eventTo !== null ? moment(eventData.eventTo) : null}
                                    format='MM/DD/YYYY'
                                    inputVariant='outlined'
                                    label="End Date"
                                    size='small'
                                    fullWidth
                                    disabled={!eventData.eventFrom}
                                    minDate={Helper.FormatDate(eventData.eventFrom)}
                                    onChange={(date) => handleChange(date, 'eventTo')}
                                    error={formDataError.eventTo && true || false}
                                    helperText={formDataError.eventTo && formDataError.eventTo}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        {/* <Grid item sm={6}>
                            <Autocomplete
                                value={eventData.gameType && eventData.gameType !== 0 ? gameTypeList.find(x => x.numericValue === eventData.gameType) : {}}
                                id="combo-box-gametype"
                                options={gameTypeList}
                                size='small'
                                getOptionLabel={(option) => option.displayName || ''}
                                fullWidth={true}
                                onChange={(event, newValue) => {
                                    if (newValue === null) {
                                        handleChange(0, 'gameType')
                                    } else {
                                        handleChange(newValue.numericValue, 'gameType')
                                    }
                                }}
                                // disabled={evaluation.evaluationID > 0 ? true : false}
                                renderInput={(params) => <TextField {...params}
                                    label={<Typography variant="body2">Game Type</Typography>}
                                    variant="outlined"
                                    error={formDataError.gameType && true || false}
                                    helperText={formDataError.gameType && formDataError.gameType}
                                />}
                            />

                        </Grid> */}
                        <Grid item sm={6}>
                            <Autocomplete
                                value={eventData.country && eventData.country !== 0 ? countryList.find(x => x.numericValue === eventData.country) : {}}
                                id="combo-box-country"
                                options={countryList}
                                size='small'
                                getOptionLabel={(option) => option.displayName || ''}
                                fullWidth={true}
                                onChange={(event, newValue) => {
                                    if (newValue === null) {
                                        handleChange(0, 'country')
                                    } else {
                                        handleChange(newValue.numericValue, 'country')
                                    }

                                }}
                                //  disabled={evaluation.evaluationID > 0 ? true : false}
                                renderInput={(params) => <TextField {...params}
                                    label={<Typography variant="body2">Country</Typography>}
                                    variant="outlined"
                                    error={formDataError.country && true || false}
                                    helperText={formDataError.country && formDataError.country}
                                />}
                            />
                        </Grid>

                        <Grid item sm={6}>
                            {eventData.country && eventData.country === 1 ? <Autocomplete
                                value={eventData.state && eventData.state !== 0 ? stateList.find(x => x.numericValue === eventData.state) : {}}
                                id="combo-box-state"
                                options={stateList}
                                size='small'
                                getOptionLabel={(option) => option.displayName || ''}
                                fullWidth={true}
                                onChange={(event, newValue) => {
                                    if (newValue === null) {
                                        handleChange(0, 'state')
                                    } else {
                                        handleChange(newValue.numericValue, 'state')
                                    }

                                }}
                                // disabled={evaluation.evaluationID > 0 ? true : false}
                                renderInput={(params) => <TextField {...params}
                                    label={<Typography variant="body2">State</Typography>} variant="outlined"
                                    error={formDataError.state && true || false}
                                    helperText={formDataError.state && formDataError.state}
                                />}
                            /> :
                                <TextField
                                    value={eventData.stateOther && eventData.stateOther}
                                    fullWidth
                                    size='small'
                                    id="evaluationdate-outlined-required"
                                    label="State Other"
                                    variant="outlined"
                                    //disabled={evaluation.evaluationID > 0 ? true : false}
                                    onChange={(e) => handleChange(e.target.value, 'stateOther')}
                                />}
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                value={eventData.city && eventData.city}
                                fullWidth
                                size='small'
                                id="evaluationdate-outlined-required"
                                label="City"
                                variant="outlined"
                                // disabled={evaluation.evaluationID > 0 ? true : false}
                                error={formDataError.city && true || false}
                                helperText={formDataError.city && formDataError.city}
                                onChange={(e) => handleChange(e.target.value, 'city')}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <Autocomplete
                                value={selectedScoutingCategory}
                                id="combo-box-scouting-category"
                                options={scoutingCategoryList}
                                size='small'
                                getOptionLabel={(option) => option.categoryName || ''}
                                getOptionSelected={(option, value) => option.id === value.id}
                                fullWidth={true}
                                onChange={(event, newValue) => handleScoutingCategoryChange(newValue)}
                                renderInput={(params) => <TextField {...params}
                                    label={<Typography variant="body2">Scouting Category</Typography>}
                                    variant="outlined"
                                    error={formDataError.scoutingCategory && true || false}
                                    helperText={formDataError.scoutingCategory && formDataError.scoutingCategory}
                                />}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <Autocomplete
                                value={selectedScoutingSubCategory}
                                id="combo-box-scouting-subcategory"
                                options={scoutingSubCategoryOptions}
                                size='small'
                                getOptionLabel={(option) => option.subCategoryName || ''}
                                getOptionSelected={(option, value) => option.id === value.id}
                                fullWidth={true}
                                disabled={scoutingSubCategoryOptions.length === 0}
                                onChange={(event, newValue) => handleScoutingSubCategoryChange(newValue)}
                                renderInput={(params) => <TextField {...params}
                                    label={<Typography variant="body2">Scouting Sub Category</Typography>}
                                    variant="outlined"
                                    error={formDataError.scoutingSubCategory && true || false}
                                    helperText={formDataError.scoutingSubCategory && formDataError.scoutingSubCategory}
                                />}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <div style={{display: 'flex'}}>
                                <FormLabel style={{ display: 'flex', alignContent: 'center', flexWrap: 'wrap', paddingRight: '10px' }} id="eventMode">Event Mode: </FormLabel>
                                <RadioGroup
                                    aria-labelledby="evaluation-mode"
                                    name="evaluation-mode"
                                    value={eventData.evaluationMode}
                                    onChange={(e) => handleChange(e.target.value, 'evaluationMode')}
                                    row
                                >
                                    <FormControlLabel value="inperson" control={<Radio />} label={<Typography variant="caption">In Person</Typography>} />
                                    <FormControlLabel value="virtual" control={<Radio />} label={<Typography variant="caption">Virtual</Typography>} />
                                </RadioGroup>
                            </div>
                            {formDataError.evaluationMode && <FormHelperText error>{formDataError.evaluationMode}</FormHelperText>}
                        </Grid>
                    </Grid>



                    {/* <Grid container style={{ paddingTop: '12px' }}>
                        <FormControlLabel
                            label="Is NBA Event"
                            labelPlacement='start'
                            control={
                                <Checkbox
                                    checked={isNBAEvent}
                                    onChange={(e) => handleChange(e.target.checked, 'isNBAEvent')}
                                    color="primary"
                                    name="isActive"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            }

                        />
                    </Grid> */}

                </DialogContent>

                <DialogActions>
                    <Button onClick={handleSubmit} color="primary" disabled={isSaving}>
                        {isSaving ? <CircularProgress size={20} /> : 'Save'}</Button>
                    <Button
                        onClick={handleClose}
                        color="primary"
                        disabled={isSaving}
                        autoFocus>Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    );
}

export default AddNewEvent;